<template>
    <Modal id="upgrade-needed" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="content">
            <div class="upgrade-svg">
                <CreditCardNeeded />
            </div>
            <div class="title">Kredi Kartı Zorunlu</div>
            <div class="description">
                Herhangi bir satın alımları için kredi kartı zorunludur. Lütfen kredi kartınızı giriniz.
            </div>
            <div class="subbutton" @click="forward">Devam Et</div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import CreditCardNeeded from "../svg/CreditCardNeeded.vue";

export default {
    name: "CreditCardNeededModal",
    components: {
        Modal,
        CreditCardNeeded,
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        forward() {
            this.$router.push("/billing");
        },
    },
};
</script>
<style lang="scss">
#upgrade-needed {
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .upgrade-svg {
            width: 100%;
            height: 100%;

            svg {
                width: 50%;
                height: 40%;
            }
        }

        .title {
            font-size: 26px;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 15px;
        }

        .description {
            font-size: 16px;
        }

        .subbutton {
            padding: 10px 30px;
            background: rgb(236, 75, 29);
            border-radius: 4px;
            font-size: 16px;
            cursor: pointer;
            color: white;
            margin-top: 15px;
        }
    }
}
</style>
